import { Pipe, PipeTransform } from '@angular/core';
import { FilterPipe } from 'ngx-filter-pipe';

@Pipe({
  name: 'customFilterBy',
  standalone: false
})
export class CustomFilterPipe implements PipeTransform {
  constructor(public filterPipe: FilterPipe) {}

  transform(value: any[], filter: any, actual: boolean = false, inverse: boolean = false): any[] {
    // Guard: ensure we only call .filter on real arrays
    if (!Array.isArray(value) || filter === undefined) {
      return value as any;
    }

    try {
      // Use ngx-filter-pipe when actual is false
      if (actual === false) {
        const transformed = this.filterPipe.transform(value, filter);
        return inverse ? value.filter((item) => !transformed.includes(item)) : transformed;
      }
    } catch (error) {
      console.error('Error in custom filter:', error);
    }

    try {
      const keys = Object.keys(filter);
      if (keys.length > 0 && Array.isArray(value)) {
        return inverse
          ? value.filter((innerValue) => innerValue[keys[0]] != filter[keys[0]])
          : value.filter((innerValue) => innerValue[keys[0]] == filter[keys[0]]);
      }
    } catch (error) {
      console.error('Error in custom filter:', error);
    }

    return value; // Default return if nothing matches
  }
}
